// extracted by mini-css-extract-plugin
export default {"code":"codeCell_code__VtUtj","link":"codeCell_link__uCzma"};